module.exports = ".company-toggle {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n\n.company-toggle .form-group {\n  margin-right: 30px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/companies/company-inventory/companyInventory.component.scss
// module id = ./src/app/views/companies/company-inventory/companyInventory.component.scss
// module chunks = main